import { useEffect, useState, useCallback } from 'react'
import { Box, Grid } from '@material-ui/core'
import { useForm, Controller } from 'react-hook-form'

import GestionAprendizajeButton from '../components/GestionAprendizajeButton'
import SearchQuestionarieLayout from '../components/SearchQuestionarieLayout'
import SearchQuestionnaireForm from './form'
import QuestionnaireTable from './table'
import NavigationButtonTop from '../components/NavigationButtonTop'
import PortalModal, { usePortalModal } from 'components/commons/PortalModal'

import { VALUES } from 'utils/constants'
import { useApiRequest } from 'utils/customHooks/useApiRequest'
import { getFromApi, postToApi } from 'actions'
import { useStateValue } from 'context/store'
import { userSettingsModule } from 'utils/utils'
import { QUESTIONNAIRE } from '../constants'
import { editPublishedQuestModalOptions } from './utils'

function SearchQuestionnaire({ setViewQuestionnarie, isComponentVisible }) {
   const [isShowingPopover, setPopoverProp] = useState(true)
   const [showError, setShowError] = useState(false)
   const [textError, setTextError] = useState('')
   const [searchFilters, setSearchFilters] = useState({})
   const [allActiveRoles, setAllActiveRoles] = useState({})

   const [{ questionaries = {} }, dispatch] = useStateValue()
   const { params, onClose, setModal } = usePortalModal()
   const [allActiveGroups, setAllActiveGroups] = useState({})

   const [tableData, setTableData] = useState(VALUES.TABLE_DATA_INTIAL_STATE)
   const [paginationParams, setPaginationParams] = useState(
      VALUES.PAGING_ORDER_INITIAL_STATE
   )

   const {
      handleSubmit,
      getValues,
      control,
      reset,
      formState: { errors, isValid }
   } = useForm({
      defaultValues: {
         name: '',
         applicationId: [],
         roles: [],
         ngroups: [],
         status: []
      },
      mode: 'onChange'
   })

   function getIdsAsStringWithBrackets(data) {
      const ids = data?.map(item => item.id)
      const idsString = ids?.join(',')
      if (data?.length > 0) {
         return idsString
      }
      return ''
   }

   async function _searchQuestionnaire(externalFilters, pagingFromTableParams) {
      const filters = externalFilters || searchFilters
      const paginationFilters = {
         ...paginationParams,
         ...pagingFromTableParams
      }
      setSearchFilters(filters)
      setPaginationParams(paginationFilters)
      const data = {}
      if (filters.name) {
         data.name = filters.name
      }
      if (filters.applicationId) {
         data.applicationId = filters.applicationId
      }
      if (filters.roles) {
         data.roles = filters.roles
      }
      if (filters.ngroups) {
         data.ngroups = filters.ngroups
      }
      if (filters.status) {
         data.status = filters.status
      }
      const payload = { ...data, ...paginationFilters }
      const url = `${process.env.REACT_APP_QUESTIONNAIRE_API}/questionnaire/search`
      const searchedQuestionnaires = await getFromApi(url, payload)
      setTableData(searchedQuestionnaires)
   }

   const searchQuestionnaire = useApiRequest(
      _searchQuestionnaire,
      'Subdominios: Consultar'
   )

   // -------------- Form Actions ---------------
   const actionSubmit = data => {
      setPopoverProp(false)
      const dataSubmit = {
         name: data.name ? data?.name : '',
         applicationId: data?.applicationId?.id ? data?.applicationId?.id : '',
         roles: getIdsAsStringWithBrackets(data?.roles) ?? 0,
         ngroups: getIdsAsStringWithBrackets(data?.ngroups) ?? 0,
         status: getIdsAsStringWithBrackets(data?.status) ?? 0
      }

      const PAGING_ORDER_INITIAL_STATE = {
         page: 0,
         size: 5,
         order: 'asc',
         columnOrder: 'code'
      }

      searchQuestionnaire(dataSubmit, PAGING_ORDER_INITIAL_STATE)
   }

   const onSubmitCallback = () => {
      const allValuesCurrent = getValues()
      actionSubmit(allValuesCurrent)
   }
   // ---------------- Clean Form -----------------

   const handleFormReset = () => {
      reset({
         name: '',
         applicationId: [],
         roles: [],
         ngroups: [],
         status: []
      })
   }

   const alertClose = () => {
      setShowError(false)
   }

   const alertOpen = () => {
      setShowError(true)
   }

   // ------------------------------ Clean data tablet ------------------------------
   const cleanDataTable = () => {
      setTableData(VALUES.TABLE_DATA_INTIAL_STATE)
      setPopoverProp(true)
   }

   // ------------- Fetch all role active  -----------------
   async function _getAllActiveRoles() {
      const url = `${process.env.REACT_APP_ROLE}/roles/active`
      const searchedRoles = await getFromApi(url)
      setAllActiveRoles(searchedRoles)
   }

   const getAllActiveRoles = useApiRequest(
      _getAllActiveRoles,
      'Role: Consultar roles Activos'
   )
   // ------------- Fetch all group active  -----------------
   async function _getAllActiveGroups() {
      const url = `${process.env.REACT_APP_GROUP}/groups/active`
      const searchedGroups = await getFromApi(url)
      setAllActiveGroups(searchedGroups)
   }

   const getAllActiveGroups = useApiRequest(
      _getAllActiveGroups,
      'Group: Consultar grupos Activos'
   )
   const postRequest = useApiRequest(postToApi, 'Questionnaire')

   const onEditQuestionaire = quest => {
      dispatch({ type: 'SaveQuest', questionaries: quest })
      setViewQuestionnarie('view-initial-form-questionnaire')
   }

   const editQuest = useCallback(questionnaire => {
      if (
         !userSettingsModule.buscarValorEnUserSettings(
            'operations',
            'EDITAR CUESTIONARIO'
         )
      ) {
         return
      }
      if (questionnaire?.status === QUESTIONNAIRE.PUBLISHED_STATUS) {
         setModal({
            ...editPublishedQuestModalOptions,
            onConfirm: async () => {
               const url = `${process.env.REACT_APP_QUESTIONNAIRE_API}/questionnaire/QuestionnairePublished`
               const duplicatedQuest = await postRequest(url, {
                  questionareId: questionnaire?.id,
                  question: true
               })
               onEditQuestionaire(duplicatedQuest)
            }
         })
      } else {
         onEditQuestionaire(questionnaire)
      }
   }, [])

   useEffect(() => {
      getAllActiveRoles()
      getAllActiveGroups()
   }, [])

   return (
      <Grid
         style={{
            display: isComponentVisible ? 'flex' : 'none',
            width: '90%',
            height: '100%',
            padding: '0 3rem',
            gap: '2rem'
         }}
      >
         <div style={{ marginRight: '3rem' }}>
            <NavigationButtonTop
               isButtonBack={true}
               setView={setViewQuestionnarie}
            />
         </div>

         <div
            style={{
               width: '100%'
            }}
         >
            <Box
               sx={{
                  width: '80%',
                  display: 'flex',
                  gap: '1rem',
                  justifyContent: 'space-between',
                  alignContent: 'center',
                  height: '40px',

                  margin: '1rem'
               }}
            >
               <div>
                  <GestionAprendizajeButton
                     setViewQuestionnarie={setViewQuestionnarie}
                  />
               </div>
            </Box>
            <Box
               sx={{
                  width: '100%',
                  display: 'flex',
                  gap: '1rem',
                  justifyContent: 'space-between',
                  alignContent: 'center',
                  margin: '1rem'
               }}
            >
               <SearchQuestionarieLayout
                  alertClose={alertClose}
                  showError={showError}
                  textError={textError}
                  title="Filtrar cuestionario"
                  form={
                     <SearchQuestionnaireForm
                        onSubmit={actionSubmit}
                        resetForm={handleFormReset}
                        handleSubmit={handleSubmit}
                        Controller={Controller}
                        control={control}
                        alertOpen={alertOpen}
                     />
                  }
                  table={
                     <QuestionnaireTable
                        isSearch
                        onSubmitCallback={onSubmitCallback}
                        order={paginationParams.order}
                        questionnaires={tableData}
                        searchQuestionnaire={searchQuestionnaire}
                        cleanCallback={cleanDataTable}
                        setViewQuestionnarie={setViewQuestionnarie}
                        allActiveRoles={allActiveRoles}
                        allActiveGroups={allActiveGroups}
                        actionEdit={editQuest}
                     />
                  }
                  popoverProp={isShowingPopover}
                  setPopoverProp={setPopoverProp}
                  cleanCallback={cleanDataTable}
               />
            </Box>
            <PortalModal params={params} onClose={onClose} />
         </div>
      </Grid>
   )
}

export default SearchQuestionnaire
